export default {
  API: `${ import.meta.env.VITE_SITE_URL }`,
  BOOKKEEPING: `${ import.meta.env.VITE_SITE_URL }/bookkeepings`,
  CRM: `${ import.meta.env.VITE_SITE_URL }/crms`,
  STAFF: `${ import.meta.env.VITE_SITE_URL }/staffs`,
  PERSON: `${ import.meta.env.VITE_SITE_URL }/persons`,
  UPSTREAM: {
    CRM: `${ import.meta.env.VITE_SITE_URL }/upstream/crms`,
  },
  DOWNSTREAM: {
    CRM: `${ import.meta.env.VITE_SITE_URL }/downstream/crms`,
    STAFF: `${ import.meta.env.VITE_SITE_URL }/downstream/staffs`,
  },
};
